import { ITerminalsDto, TerminalsDto } from "../../models/TerminalsDto";
import { ITerminalDto, TerminalDto } from "../../models/TerminalDto";
import { TidStatusDto } from "../../models/TidStatusDto";
import { IMposWebPortalApi } from "./IMposWebPortalApi";
import { Observable, Subscriber } from "rxjs";
import { ISuperUserDto, SuperUserDto } from "../../models/SuperUserDto";
import { IUsersDto, UsersDto } from "../../models/UsersDto";
import { IDevelopersDto, DevelopersDto } from "../../models/DevelopersDto";
import { IDeveloperDto, DeveloperDto } from "../../models/DeveloperDto";
import { IUserDto, UserDto } from "../../models/UserDto";
import { TerminalItemDto } from "../../models/TerminalInfoDto";
import { IAddUserRequest } from "../../models/AddUserRequest";
import {
  AddUserResponse,
  IAddUserResponse,
} from "../../models/AddUserResponse";
import { IUserDetailsDto, UserDetails } from "../../models/UserDetailsDto";
import { IDeveloperDetailsDto, DeveloperDetails } from "../../models/DeveloperDetailsDto";
import { sessionStorageInstance } from "../storage/Storage";
import { IUpdateUserRequestDto } from "../../models/UpdateUserDetails";
import { ITerminalUpdateOrRemoveDto } from "../../models/TerminalUpdateOrRemove";
import { IGetTCRequest } from "../../models/GetTCRequest";
import { IGetTCResponse } from "../../models/GetTCResponse";
import { IUpdateTCRequest } from "../../models/UpdateTCRequest";
import { ICategoriesDto } from "../../models/CategoriesDto";
import { CatalogDto, ICatalogDto } from "../../models/CatalogDto";
import { CategoryDto, ICategoryDto } from "../../models/CategoryDto";
import { IProductsDto } from "../../models/ProductsDto";
import { IDuplicateCategoryRequest } from "../../models/DuplicateCategoryRequest";
import { IProductDto } from "../../models/ProductDto";
import { IProductDetailDto } from "../../models/ProductDetailDto";
import { IAddOrRemoveProductFromCategory } from "../../models/AddOrRemoveProductFromCategory";
import { IUpdateProductCategoriesDto } from "../../models/UpdateProductCategoriesDto";
import { IFileResponse } from "../../models/FileResponse";
import { IUploadFileRequest } from "../../models/UploadFileRequest";
import { IUploadFileResponse } from "../../models/UploadFileResponse";
import { IApplicationsDto, ApplicationsDto } from "../../models/ApplicationsDto";
import { IApplicationDto, ApplicationDto } from "../../models/ApplicationDto";
import { HTTPResponses } from "../../models/HTTPResponses";
import { IMerchantDto, MerchantDto } from "../../models/MerchantDto";
import { IMerchantsDto, MerchantsDto } from "../../models/MerchantsDto";
import moment from "moment";
import { IApplicationDetailDto, ApplicationDetails } from "../../models/ApplicationDetailsDto";

export class MockApi implements IMposWebPortalApi {
  private static instance: MockApi;

  private constructor() { }

  public static getInstance(): MockApi {
    if (!MockApi.instance) {
      MockApi.instance = new MockApi();
    }

    return MockApi.instance;
  }

  public getTerminals(): Observable<ITerminalsDto> {
    return Observable.create((subscriber: Subscriber<ITerminalsDto>) => {
      let terminalsDto = new TerminalsDto();
      let terminals: ITerminalDto[] = [
        new TerminalDto("09827891", TidStatusDto.ACTIVE, "MPOS", ["manuela.ciancilla_01", "caterina.rutschmann_01"], ""),
        new TerminalDto("09827892", TidStatusDto.SUSPENDED, "MPOS", [], ""),
        new TerminalDto("09827893", TidStatusDto.SUSPENDED, "MPOS", [], "A"),
        new TerminalDto("09827894", TidStatusDto.SUSPENDED, "MPOS", ["manuela.ciancilla_01", "caterina.rutschmann_01"], ""),
        new TerminalDto("09827896", TidStatusDto.SUSPENDED, "MPOS", [], "B"),
        new TerminalDto("35695097", TidStatusDto.SUSPENDED, "MPOS", [], ""),
        new TerminalDto("1358147802", TidStatusDto.ACTIVE, "SOFTPOS", [], ""),
        new TerminalDto("2114587283", TidStatusDto.SUSPENDED, "SOFTPOS", [], ""),
        new TerminalDto("2384562583", TidStatusDto.SUSPENDED, "SOFTPOS", [], ""),
        new TerminalDto("1702579061", TidStatusDto.SUSPENDED, "SOFTPOS", [], ""),
        new TerminalDto("3907928872", TidStatusDto.SUSPENDED, "SOFTPOS", [], ""),
        new TerminalDto("966503718", TidStatusDto.SUSPENDED, "SOFTPOS", [], ""),
      ];

      //terminalsDto.terminals = terminals.slice(0, n);
      terminalsDto.terminals = terminals;
      subscriber.next(terminalsDto);
    });
  }

  getSuperUserDetails(): Observable<ISuperUserDto> {
    return new Observable((subscriber: Subscriber<ISuperUserDto>) => {
      let data = new SuperUserDto(
        "8141756",
        "ca.ruggieri@test.it",
        "Carmine",
        5,
        18,
        0,
        "Ruggieri",
        "STUB_ca.ruggieri",
        [
          new TerminalItemDto("8141756", TidStatusDto.SUSPENDED, "MPOS", ""),
          new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "SOFTPOS", "A"),
        ],
        "AMMINISTRATORE"
      );
      sessionStorageInstance.setData("user", data);
      subscriber.next(data);
    });
  }

  getUsers(): Observable<IUsersDto> {
    return new Observable((subscriber: Subscriber<IUsersDto>) => {
      const n = 10;
      let usersDto = new UsersDto();
      let users: IUserDto[] = [
        new UserDto(
          "8141756",
          "Staff - Torino",
          "ca.ruggieri@test.it",
          "Carmine",
          "Ruggieri",
          "DIPENDENTE",
          "ca.ruggieri",
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("8141756", TidStatusDto.SUSPENDED, "SOFTPOS", "A"),
          ]
        ),
        new UserDto(
          "1234567",
          "Staff",
          "caterina.rutschmann_01",
          "Caterina",
          "Rutschmann",
          "DIPENDENTE",
          "caterina.rutschmann_01",
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", null),
          ]
        ),
        new UserDto(
          "1234567",
          "Staff - Ticinese",
          "caterina.rutschmann_02",
          "Caterina",
          "Rutschmann",
          "DIPENDENTE",
          "caterina.rutschmann_02",
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("8141756", TidStatusDto.SUSPENDED, "SOFTPOS", "A"),
          ]
        ),
        new UserDto(
          "1234567",
          "Staff - Corso Sempione",
          "caterina.rutschmann_03",
          "Caterina",
          "Rutschmann",
          "DIPENDENTE",
          "caterina.rutschmann_03",
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("", TidStatusDto.SUSPENDED, "SOFTPOS", ""),
          ]
        ),
        new UserDto(
          "1234567",
          "Staff - Corso Sempione 15",
          "caterina.rutschmann_04",
          "Caterina",
          "Rutschmann",
          "DIPENDENTE",
          "caterina.rutschmann_04",
          []
        ),
        new UserDto(
          "1234567",
          "Staff - Milano Centrale",
          "alberto.rossi_02",
          "Alberto",
          "Rossi",
          "DIPENDENTE",
          "alberto.rossi_02",
          []
        ),
        new UserDto(
          "1234567",
          "Staff - Milano Rogoredro",
          "alberto.rossi_01",
          "Alberto",
          "Rossi",
          "DIPENDENTE",
          "alberto.rossi_01",
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("", TidStatusDto.NOT_ASSIGNED, "SOFTPOS", ""),
          ]
        ),
        new UserDto(
          "1234567",
          null,
          "paolo.montrasi_03",
          "Paolo",
          "Montrasi",
          "DIPENDENTE",
          "paolo.montrasi_03",
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("8141756", TidStatusDto.SUSPENDED, "SOFTPOS", "A"),
          ]
        ),
        new UserDto(
          "1234567",
          null,
          "paolo.montrasi_02",
          "Paolo",
          "Montrasi",
          "DIPENDENTE",
          "paolo.montrasi_02",
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("8141756", TidStatusDto.SUSPENDED, "SOFTPOS", "A"),
          ]
        ),
        new UserDto(
          "1234567",
          null,
          "paolo.montrasi_04",
          "Paolo",
          "Montrasi",
          "DIPENDENTE",
          "paolo.montrasi_04",
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("8141756", TidStatusDto.SUSPENDED, "SOFTPOS", "A"),
          ]
        ),
        new UserDto(
          "1234567",
          null,
          "paolo.montrasi_04",
          "Paolo",
          "Montrasi",
          "DIPENDENTE",
          "paolo.montrasi_04",
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("8141756", TidStatusDto.SUSPENDED, "SOFTPOS", "A"),
          ]
        ),
        new UserDto(
          "1234567",
          null,
          "paolo.montrasi_04",
          "Paolo",
          "Montrasi",
          "DIPENDENTE",
          "paolo.montrasi_04",
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("8141756", TidStatusDto.SUSPENDED, "SOFTPOS", "A"),
          ]
        ),
        new UserDto(
          "1234567",
          null,
          "paolo.montrasi_04",
          "Paolo",
          "Montrasi",
          "DIPENDENTE",
          "paolo.montrasi_04",
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("8141756", TidStatusDto.SUSPENDED, "SOFTPOS", "A"),
          ]
        ),
      ];
      usersDto.users = users.slice(0, n);
      subscriber.next(usersDto);
    });
  }

  addUser(request: IAddUserRequest): Observable<IAddUserResponse> {
    console.log("[MockAPI] Called addUser with request: " + JSON.stringify(request));
    return new Observable((subscriber: Subscriber<IAddUserResponse>) => {
      setTimeout(() => {
        subscriber.next(new AddUserResponse("paolo.montrasi_03"));
      }, 2500);
    });
  }

  userDetails(username: string): Observable<IUserDetailsDto> {
    return new Observable((subscriber: Subscriber<IUserDetailsDto>) => {
      subscriber.next(
        new UserDetails(
          "8141756",
          "ca.ruggieri@test.it",
          "Carmine",
          "Ruggieri",
          "ca.ruggieri",
          [
            new TerminalItemDto("", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("", TidStatusDto.SUSPENDED, "SOFTPOS", "A"),
          ],
          "2020-10-02 15:34:45.09",
          "DIPENDENTE",
          "Staff - Torino"
        )
      );
    });
  }


  getAppDetails(contractCode: string): Observable<IApplicationDetailDto> {
    console.log("[MockAPI] 🏆 Called applicationDetails with request: " + JSON.stringify(contractCode));
    return new Observable((subscriber: Subscriber<IApplicationDetailDto>) => {
      let app = new ApplicationDetails(
        null,
        0,
        '3a999ca9-8b5b-4cb3-8b26-d5e422e23f65',
        '5520e086-5b6f-450d-8409-6751f01691fa',
      );

      // Restituisci l'oggetto ApplicationsDto come risultato dell'Observable
      subscriber.next(app);
    });
  }


  deleteUser(username: string): Observable<boolean> {
    return new Observable((subscriber: Subscriber<boolean>) => {
      subscriber.next(false);
    });
  }

  resetPassword(username: string, mail: string): Observable<boolean> {
    return new Observable((subscriber: Subscriber<boolean>) => {
      subscriber.next(false);
    });
  }

  updateUserDetails(request: IUpdateUserRequestDto): Observable<boolean> {
    return new Observable((subscriber: Subscriber<boolean>) => {
      subscriber.next(true);
    });
  }

  updateTerminalToUser(
    request: ITerminalUpdateOrRemoveDto
  ): Observable<boolean> {
    console.log("[MockApi] updateTerminalToUser: " + JSON.stringify(request));
    return new Observable((subscriber: Subscriber<boolean>) => {
      subscriber.next(true);
    });
  }

  removeTerminalToUser(
    request: ITerminalUpdateOrRemoveDto
  ): Observable<boolean> {
    console.log("[MockApi] removeTerminalToUser: " + JSON.stringify(request));
    return new Observable((subscriber: Subscriber<boolean>) => {
      subscriber.next(true);
    });
  }

  getTCStatus(request: IGetTCRequest): Observable<IGetTCResponse> {
    console.log("[MockApi] getTCStatus: " + JSON.stringify(request));
    throw new Error("Method not implemented.");
  }

  updateTCStatus(request: IUpdateTCRequest): Observable<boolean> {
    console.log("[MockApi] updateTCStatus: " + JSON.stringify(request));
    throw new Error("Method not implemented.");
  }

  getCatalog(): Observable<ICatalogDto> {
    console.log("[MockApi] getCatalog");
    return new Observable((subscriber: Subscriber<ICatalogDto>) => {
      let catalog = new CatalogDto();
      catalog.categories?.push(
        new CategoryDto(
          "6733d0bd-9ea3-4daf-b67d-acc7cab3d50a",
          "#666666",
          "Senza categoria",
          "2"
        ),
        new CategoryDto(
          "6733d0bd-9ea3-4daf-b67d-acc7cab3d50b",
          "#E34263",
          "Menu estate",
          "2"
        ),
        new CategoryDto(
          "6733d0bd-9ea3-4daf-b67d-acc7cab3d50c",
          "#E34263",
          "Menu inverno",
          "2"
        )
      );
      subscriber.next(catalog);
    });
  }

  addCategory(request: ICategoriesDto): Observable<boolean> {
    console.log("[MockApi] addCategory " + JSON.stringify(request));
    throw new Error("Method not implemented.");
  }

  updateCategory(request: ICategoryDto): Observable<boolean> {
    console.log("[MockApi] updateCategory " + JSON.stringify(request));
    return new Observable((subscriber: Subscriber<boolean>) => {
      subscriber.next(false);
    });
  }

  deleteCategory(request: ICategoryDto): Observable<boolean> {
    console.log("[MockApi] deleteCategory " + JSON.stringify(request));
    return new Observable((subscriber: Subscriber<boolean>) => {
      subscriber.next(true);
    });
  }

  getProductsForCategory(id: string): Observable<IProductsDto> {
    console.log("[MockApi] getProductsForCategory " + id);
    throw new Error("Method not implemented.");
  }

  copyCategory(request: IDuplicateCategoryRequest): Observable<any> {
    console.log("[MockApi] copyCategory " + JSON.stringify(request));
    return new Observable((subscriber: Subscriber<any>) => {
      subscriber.next({});
    });
  }

  deleteProduct(request: IProductDto): Observable<boolean> {
    console.log("[MockApi] deleteProduct " + JSON.stringify(request));
    return new Observable((subscriber: Subscriber<boolean>) => {
      subscriber.next(true);
    });
  }

  getCategories(): Observable<ICategoriesDto> {
    console.log("[MockApi] getCategories");
    throw new Error("Method not implemented.");
  }

  addProduct(request: IProductsDto): Observable<boolean> {
    console.log("[MockApi] addProduct");
    throw new Error("Method not implemented.");
  }

  updateProduct(request: IProductDto): Observable<boolean> {
    console.log("[MockApi] updateProduct");
    throw new Error("Method not implemented.");
  }

  getProduct(id: string): Observable<IProductDetailDto> {
    console.log("[MockApi] getProduct");
    throw new Error("Method not implemented.");
  }

  removeProductsFromCategory(
    request: IAddOrRemoveProductFromCategory
  ): Observable<boolean> {
    console.log("[MockApi] removeProductsFromCategory");
    throw new Error("Method not implemented.");
  }

  addProductsToCategory(
    request: IAddOrRemoveProductFromCategory
  ): Observable<boolean> {
    console.log("[MockApi] addProductsToCategory");
    throw new Error("Method not implemented.");
  }

  getProducts(): Observable<IProductsDto> {
    console.log("[MockApi] getProducts");
    throw new Error("Method not implemented.");
  }

  updateProductCategories(
    id: string,
    request: IUpdateProductCategoriesDto
  ): Observable<IProductDto> {
    console.log("[MockApi] updateProductCategories");
    throw new Error("Method not implemented.");
  }

  getCatalogFile(): Observable<IFileResponse> {
    console.log("[MockApi] getCatalogFile");
    throw new Error("Method not implemented.");
  }

  getTemplateFile(): Observable<IFileResponse> {
    console.log("[MockApi] getTemplateFile");
    throw new Error("Method not implemented.");
  }

  uploadFile(request: IUploadFileRequest): Observable<IUploadFileResponse> {
    console.log("[MockApi] uploadFile");
    throw new Error("Method not implemented.");
  }

  public getApps(request: any): Observable<IApplicationsDto> {
    return Observable.create((subscriber: Subscriber<IApplicationsDto>) => {
      const n = 20;
      let applications: IApplicationDto[] = [
        new ApplicationDto(
          "03183450231",
          'App1',
          // [
          //   {
          //     merchantId: '34785899912',
          //     piva: '34785899912',
          //     merchant: 'Cavani',
          //   },
          //   {
          //     merchantId: '34785899912',
          //     piva: '34785899912',
          //     merchant: 'Lavezzi',
          //   },
          // ]
        )
      ];
      let applicationsDto = new ApplicationsDto(applications, n);

      applicationsDto.Apps = applications.slice(0, n);
      applicationsDto.totalNumApps = n;
      subscriber.next(applicationsDto);
    });
  }

  deleteApp(appId: string | null): Observable<HTTPResponses> {
    return new Observable((subscriber: Subscriber<HTTPResponses>) => {
      setTimeout(() => {
        subscriber.next(HTTPResponses.OK);
      }, 1500);
    });
  }

  addMerchantsToApp(request: any): Observable<HTTPResponses> {
    return new Observable((subscriber: Subscriber<HTTPResponses>) => {
      setTimeout(() => {
        subscriber.next(HTTPResponses.OK);
      }, 1500);
    });
  }

  removeMerchantFromApp(request: any): Observable<HTTPResponses> {
    return new Observable((subscriber: Subscriber<HTTPResponses>) => {
      setTimeout(() => {
        subscriber.next(HTTPResponses.OK);
      }, 1500);
    });
  }

  searchMerchant(request: any): Observable<any> {
    return new Observable((subscriber: any) => {
      let merchantsDto = new MerchantsDto();
      let merchants: IMerchantDto[] = [
        new MerchantDto(
          "09827891", // merchant id
          "2400011110", // merchant
          "App1", // appName
          "ATTIVA", // app status
          "2223331119", // piva
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("8141757", TidStatusDto.SUSPENDED, "SOFTPOS", "A"),
          ], // terminalInfo
          moment("27/07/2023", "DD/MM/YYYY").toISOString(), // appCreation
        )
      ];

      merchantsDto.merchants = merchants;
      subscriber.next(merchantsDto);
    });
  }

  createApp(appName: string | null, merchants: string[] | null, redirect_uri: string | null): Observable<HTTPResponses> {
    return new Observable((subscriber: Subscriber<HTTPResponses>) => {
      setTimeout(() => {
        subscriber.next(HTTPResponses.OK);
      }, 1500);
    });
  }

  addDeveloper(email: string): Observable<HTTPResponses> {
    return new Observable((subscriber: Subscriber<HTTPResponses>) => {
      setTimeout(() => {
        subscriber.next(HTTPResponses.OK);
      }, 1500);
    });
  }

  getDevelopers(): Observable<IDevelopersDto> {
    return new Observable((subscriber: Subscriber<IDevelopersDto>) => {
      let developersDto = new DevelopersDto();
      let developers: IDeveloperDto[] = [
        new DeveloperDto(
          "ma.rossi@test.it",
          "SVILUPPATORE",
        ),
        new DeveloperDto(
          "lu.luigi@test.it",
          "SVILUPPATORE",
        ),
      ];
      developersDto.developers = developers;
      subscriber.next(developersDto);
    });
  };

  developerDetails(username: string): Observable<IDeveloperDetailsDto> {
    return new Observable((subscriber: Subscriber<IDeveloperDetailsDto>) => {
      subscriber.next(
        new DeveloperDetails(
          "lu.luigi@test.it",
          "SVILUPPATORE",
        ),
      );
    });
  }

  removeDeveloper(email: string): Observable<HTTPResponses> {
    console.log("[MockAPI] Called removeDeveloper with request: " + JSON.stringify(email));
    return new Observable((subscriber: Subscriber<HTTPResponses>) => {
      setTimeout(() => {
        subscriber.next(HTTPResponses.OK);
      }, 2500);
    });
  }

  uploadCertificate(request: any): Observable<HTTPResponses> {
    console.log("[MockAPI] Called uploadCertificate with request: " + JSON.stringify(request));
    return new Observable((subscriber: Subscriber<HTTPResponses>) => {
      setTimeout(() => {
        subscriber.next(HTTPResponses.OK);
      }, 2500);
    });
  }

  getMerchants(): Observable<IMerchantsDto> {
    return Observable.create((subscriber: Subscriber<IMerchantsDto>) => {
      let merchantsDto = new MerchantsDto();
      let merchants: IMerchantDto[] = [
        new MerchantDto(
          "09827891", // merchant id
          "2400011110", // merchant
          "App1", // appName
          "ATTIVA", // app status
          "2223331119", // piva
          [
            new TerminalItemDto("8141756", TidStatusDto.ACTIVE, "MPOS", ""),
            new TerminalItemDto("8141757", TidStatusDto.SUSPENDED, "SOFTPOS", "A"),
          ], // terminalInfo
          moment("27/07/2023", "DD/MM/YYYY").toISOString(), // appCreation
        )
      ];

      merchantsDto.merchants = merchants;
      subscriber.next(merchantsDto);
    });
  }

  userLogin(): Observable<any> {
    console.log("[MockAPI] Called userLogin");
    return new Observable((subscriber: Subscriber<any>) => {
      setTimeout(() => {
        subscriber.next({
          id: 3777,
          email: "l.ngankemngankem@nexidigital.eu",
          userType: "SVILUPPATORE",
          certificate: true
        });
      }, 2500);
    });
  }
}
